import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TuiTextfieldControllerModule, TuiMultiSelectModule } from '@taiga-ui/legacy';
import { TuiActiveZone } from '@taiga-ui/cdk';
import { TuiLoader, TuiDropdown } from '@taiga-ui/core';
import { AccordionLevelsModule } from '@src/app/modules/accordion-levels';
import { SharedModule } from '@src/app/shared';

import { CustomNamesTabsModule } from '../../custom-name-tabs';

import { CommitteeFieldComponent } from './committee-field.component';

@NgModule({
  declarations: [CommitteeFieldComponent],
  imports: [
    AccordionLevelsModule,
    CommonModule,
    FormsModule,
    SharedModule,
    TuiActiveZone,
    ...TuiDropdown,
    TuiLoader,
    TuiMultiSelectModule,
    TuiTextfieldControllerModule,
    CustomNamesTabsModule,
  ],
  exports: [CommitteeFieldComponent],
})
export class CommitteeFieldModule {}
